<template>
	<div class="flex flex-wrap">
		<div class="flex-col-12 flex-centerize">
			<div class="flex-col-12 text-align-center">
				<h1>{{ isExtensionInstalled ? 'Update' : 'Install' }} the ply extension for chrome</h1>
				<div class="pt-5"><ChromeExtensionSVG /></div>
				<div class="pt-3"><Loader small primary :key="loaderKey" /></div>
				<h4 class="waiting-message pt-1">Waiting to detect chrome extension</h4>
				<div class="pt-5">
					<span class="text-underline action" role="button" @click="checkExtensionInstalled">Check again</span>
				</div>
			</div>
		</div>
		<div class="flex-1 flex-center--end flex-wrap">
			<div class="button-area flex-col-3">
				<PrimaryButton @click="openChromeStore" class="width-100">Open Chrome Store</PrimaryButton>
			</div>
		</div>
	</div>
</template>

<script>
import ChromeExtensionSVG from '@/views/userRegistration/assets/ChromeExtensionSVG.vue';
import Loader from '@/components/common/Loader.vue';
import ExtensionCommunicationService from '@/utils/extension-communication-service';

/**
 * InstallPlyExtensionLoader assumes whoever uses this component, already checked and extension is not installed
 * fires 'extension-installed' event when extension is installed
 */

export default {
	name: 'InstallPlyExtensionLoader',
	components: { ChromeExtensionSVG, Loader },
	props: { minimalVersion: { type: String } },
	methods: {
		openChromeStore() {
			const { VUE_APP_CHROME_EXTENSION_APP_URL: chromeAppURL } = process.env;
			window.open(chromeAppURL, '_blank');
		},
		extensionInstalled() {
			this.$emit('extension-installed');
		},
		async checkExtensionInstalled() {
			this.loaderKey++;
			this.isExtensionInstalled = await ExtensionCommunicationService.isInstalled();
			if (this.isExtensionInstalled) {
				await this.checkIfExtensionVersionIsValid();
			}
		},
		async versionOfExtensionIsValid() {
			return !this.minimalVersion || (await ExtensionCommunicationService.isExtensionVersionGTEToVersion(this.minimalVersion));
		},
		async checkIfExtensionVersionIsValid() {
			const isVersionValid = await this.versionOfExtensionIsValid();
			if (isVersionValid) {
				this.extensionInstalled();
			}
		},
	},
	async mounted() {
		await this.checkExtensionInstalled();
		this.unsubscribeToken = ExtensionCommunicationService.subscribeToExtensionInstalled(this.checkIfExtensionVersionIsValid);
		this.isExtensionInstalled &&
			this.minimalVersion &&
			(this.unsubscribeVersionToken = ExtensionCommunicationService.subscribeToExtensionVersionSatisfied(
				this.minimalVersion,
				this.checkIfExtensionVersionIsValid
			));
	},
	beforeDestroy() {
		this.unsubscribeToken && ExtensionCommunicationService.unsubscribeToExtensionInstalled(this.unsubscribeToken);
		this.unsubscribeVersionToken && ExtensionCommunicationService.unsubscribeToExtensionVersionSatisfied(this.unsubscribeVersionToken);
	},
	data() {
		return {
			unsubscribeToken: null,
			unsubscribeVersionToken: null,
			loaderKey: 0, // used to re-render loader
			isExtensionInstalled: false,
		};
	},
};
</script>

<style scoped lang="scss">
.waiting-message {
	opacity: 0.5;
}
span.action {
	color: var(--primary-color);
}
.button-area {
	min-width: 240px;
}
</style>
